import { createAsyncAction } from "typesafe-actions";
import { WithNavigate } from "@shared/interfaces";

import { AuthActionTypes } from "./constants";
import {
  LoginShape,
  LoginSuccess,
  RegisterShape,
  ForgotPasswordShape,
  ForgotPasswordSuccess,
  SetPasswordFormShape,
  VerifySuccess,
  VerifyShape,
} from "../interfaces";

export const login = createAsyncAction(
  AuthActionTypes.LOGIN,
  AuthActionTypes.LOGIN_SUCCESS,
  AuthActionTypes.LOGIN_FAILURE,
)<WithNavigate<LoginShape>, LoginSuccess, Error>();

export const verify = createAsyncAction(
  AuthActionTypes.VERIFY_USER,
  AuthActionTypes.VERIFY_USER_SUCCESS,
  AuthActionTypes.VERIFY_USER_FAILURE,
)<WithNavigate<VerifyShape>, VerifySuccess, Error>();
export const forgotPassword = createAsyncAction(
  AuthActionTypes.FORGOT_PASSWORD,
  AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
  AuthActionTypes.FORGOT_PASSWORD_FAILURE,
)<ForgotPasswordShape, ForgotPasswordSuccess, Error>();

export const logout = createAsyncAction(
  AuthActionTypes.LOGOUT,
  AuthActionTypes.LOGOUT_SUCCESS,
  AuthActionTypes.LOGOUT_FAILURE,
)<undefined, undefined, Error>();

export const setPassword = createAsyncAction(
  AuthActionTypes.SET_PASSWORD,
  AuthActionTypes.SET_PASSWORD_SUCCESS,
  AuthActionTypes.SET_PASSWORD_FAILURE,
)<WithNavigate<SetPasswordFormShape>, LoginSuccess, Error>();

export const registration = createAsyncAction(
  AuthActionTypes.REGISTRATION,
  AuthActionTypes.REGISTRATION_SUCCESS,
  AuthActionTypes.REGISTRATION_FAILURE,
)<RegisterShape, undefined, Error>();
